(function () {
  function currentIndex(root) {
    return parseInt(root.getAttribute("data-mp-about-index") || "0", 10) || 0;
  }

  function goTo(root, nextIndex) {
    var viewport = root.querySelector("[data-mp-about-viewport]");
    var track = root.querySelector("[data-mp-about-track]");
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-mp-about-slide]"));
    var dots = Array.prototype.slice.call(root.querySelectorAll("[data-mp-about-dot]"));
    if (!viewport || !track || !slides.length) return;

    var index = ((nextIndex % slides.length) + slides.length) % slides.length;
    root.setAttribute("data-mp-about-index", String(index));

    if (root.getAttribute("data-mp-carousel") === "fade") {
      track.style.transform = "none";
      track.style.height = slides[index].offsetHeight + "px";
    } else {
      var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      var slideLeft = 0;
      for (var i = 0; i < index; i += 1) {
        slideLeft += slides[i].offsetWidth + gap;
      }
      var centerOffset = slideLeft - (viewport.clientWidth - slides[index].offsetWidth) / 2;
      track.style.transform = "translate3d(" + -Math.round(centerOffset) + "px,0,0)";
    }

    var status = root.querySelector("[data-mp-about-status]");
    if (status) status.textContent = (index + 1) + " of " + slides.length;

    slides.forEach(function (slide, i) {
      var active = i === index;
      slide.classList.toggle("is-active", active);
      slide.toggleAttribute("aria-current", active);
      slide.toggleAttribute("aria-hidden", !active);
    });

    dots.forEach(function (dot, i) {
      var active = i === index;
      dot.classList.toggle("is-active", active);
      dot.setAttribute("aria-selected", active ? "true" : "false");
    });
  }

  function step(root, direction) {
    goTo(root, currentIndex(root) + direction);
  }

  window.mpAboutGo = function (el, direction) {
    var root = el && el.closest("[data-mp-about-chapters]");
    if (!root) return false;
    step(root, direction);
    return false;
  };

  function bindSwipe(root) {
    var viewport = root.querySelector("[data-mp-about-viewport]");
    if (!viewport) return;
    var startX = 0;
    var startY = 0;
    var dragging = false;

    viewport.addEventListener("pointerdown", function (event) {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      startX = event.clientX;
      startY = event.clientY;
      dragging = true;
    });

    viewport.addEventListener("pointerup", function (event) {
      if (!dragging) return;
      dragging = false;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      step(root, dx < 0 ? 1 : -1);
    });

    viewport.addEventListener("pointercancel", function () {
      dragging = false;
    });
  }

  function bindRoot(root) {
    if (root.getAttribute("data-mp-about-bound") === "true") return;
    root.setAttribute("data-mp-about-bound", "true");

    var prev = root.querySelector("[data-mp-about-prev]");
    var next = root.querySelector("[data-mp-about-next]");
    var dots = root.querySelectorAll("[data-mp-about-dot]");

    if (prev) {
      prev.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        step(root, -1);
      });
    }

    if (next) {
      next.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        step(root, 1);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        goTo(root, i);
      });
    });

    root.addEventListener("keydown", function (event) {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        step(root, -1);
      }
      if (event.key === "ArrowRight") {
        event.preventDefault();
        step(root, 1);
      }
    });

    bindSwipe(root);
    goTo(root, currentIndex(root));
  }

  function boot() {
    document.querySelectorAll("[data-mp-carousel]").forEach(function (root) {
      var track = root.querySelector("[data-mp-about-track]");
      if (track && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        track.style.transition = "none";
      }
      bindRoot(root);
    });
  }

  window.addEventListener("resize", function () {
    document.querySelectorAll("[data-mp-carousel]").forEach(function (root) {
      goTo(root, currentIndex(root));
    });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
